import { lookup } from 'mime-types'
import { KnowledgeBaseDisplayContentType } from 'types/KnowledgeBaseDisplayContentType'
import { MetadataRecord } from 'api/types'
import { MetadataEntry } from 'types/MetadataEntry'

const getCleanFileExtension = (downloadFilePath: string) => {
  const cleanPath = downloadFilePath.split(/[?#]/)[0]
  const filename = cleanPath.split('/').pop()

  if (!filename || !filename.includes('.')) {
    return ''
  }

  return filename.split('.').pop()?.toLowerCase() || ''
}

const getMimeTypeFromDownloadFilePath = (downloadFilePath: string) => {
  const fileExtension = getCleanFileExtension(downloadFilePath)
  const mimeType = lookup(fileExtension) || 'UNSUPPORTED'
  return mimeType
}

const getKnowledgeBaseDisplayContentType = (mimeType: string) => {
  if (mimeType.startsWith('image/')) return KnowledgeBaseDisplayContentType.IMAGE
  if (mimeType.startsWith('video/')) return KnowledgeBaseDisplayContentType.VIDEO
  if (mimeType.startsWith('audio/')) return KnowledgeBaseDisplayContentType.AUDIO
  if (mimeType === 'application/pdf') return KnowledgeBaseDisplayContentType.PDF

  return KnowledgeBaseDisplayContentType.UNSUPPORTED
}

const metadataRecordToMetadataEntries = (metadataRecord?: MetadataRecord): MetadataEntry[] =>
  Object.entries(metadataRecord || {}).map(
    ([key, value]) => {
      const noParsingNeeded = typeof value === 'string'

      return {
        key,
        value: noParsingNeeded ? String(value) : JSON.stringify(value),
        isJSON: !noParsingNeeded
      }
    }
  )

const metadataEntriesToMetadataRecord = (metadataEntries?: MetadataEntry[]): MetadataRecord =>
  (metadataEntries || []).reduce<MetadataRecord>((acc, { key, value, isJSON }) => {
    acc[key] = isJSON ? JSON.parse(value) : value
    return acc
  }, {})

export {
  getMimeTypeFromDownloadFilePath,
  getKnowledgeBaseDisplayContentType,
  metadataRecordToMetadataEntries,
  metadataEntriesToMetadataRecord,
}
